import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';
import { d as dateFnsExports } from './p-iWCgRMLC.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$b } from './p-BedvZv52.js';
import { d as defineCustomElement$a } from './p-CkgLRZPl.js';
import { d as defineCustomElement$9 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$8 } from './p-BVCTlSQE.js';
import { d as defineCustomElement$7 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$6 } from './p-CPK1giqP.js';
import { d as defineCustomElement$5 } from './p-JbeHhSQA.js';
import { d as defineCustomElement$4 } from './p-Birh0vlD.js';
import { d as defineCustomElement$3 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$2 } from './p-QtR5VUMp.js';

const pageHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--jw-theme-surface-elevated-default-bg-color);box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .header-container{align-items:flex-start;align-self:stretch;display:flex;flex-direction:column;gap:.75rem;padding:1.5rem}:host .top-content-container{display:flex;gap:.75rem;justify-content:space-between;width:100%}:host .left-header-container{align-items:center;display:flex;gap:.75rem}:host .right-header-container{align-items:center;display:flex;gap:1rem;white-space:nowrap}:host .title-container{align-items:center;display:inline-grid;gap:.125rem;grid-template-columns:minmax(11rem,1fr) auto}:host .title-container:has(h1~h1){grid-template-columns:minmax(4rem,auto) auto minmax(11rem,1fr) auto}:host .last-saved-timestamp{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem}:host .current-page-title-container{background:none;border:none;cursor:auto;display:flex;gap:.125rem;height:auto;margin:0;padding:0;width:auto}:host wui-icon{color:var(--jw-theme-surface-text-helper-color)}:host h1{font-family:Open Sans;font-size:1.5rem;font-weight:400;letter-spacing:-.0008em;line-height:2rem;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host h1.page-title{color:var(--jw-theme-surface-text-default-color)}:host h1.parent-title{color:var(--jw-theme-surface-text-helper-color);white-space:nowrap}:host ::slotted([slot=subtitleSection]){width:100%}:host .header-tabs-container{border-bottom:1px solid var(--jw-theme-surface-border-border-color);padding:0 1.5rem}:host .header-tabs-container wui-tabs{box-shadow:none}@media only screen and (max-width:48rem){.top-content-container{flex-wrap:wrap;gap:.75rem}.right-header-container{align-self:flex-end;margin-left:auto}}";

const WuiPageHeader$1 = /*@__PURE__*/ proxyCustomElement(class WuiPageHeader extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * Current page title
         *
         */
        this.currentPageTitle = '';
        /**
         * Page description, displayed underneath title
         *
         * If more advanced markup is required, use the `description` slot.
         */
        this.description = '';
        /**
         * Array of buttons to be shown as action menu
         *
         */
        this.menu = [];
    }
    renderLastSavedTimestamp() {
        if (!this.lastSaved)
            return null;
        return h("span", { class: "last-saved-timestamp" }, "Last saved ", dateFnsExports.formatDistanceToNow(this.lastSaved), " ago");
    }
    render() {
        return (h(Host, { key: 'f55c3c13c3bfd77d153fed8d6f2f6e50d11e8d27' }, h("header", { key: '4d36a9b00411e4822622746d72dfdd7624653491', class: "header-container" }, h("section", { key: 'd6dbfca8605b8c3dc0401e55367aa7bbae1573d3', class: "top-content-container" }, h("div", { key: 'dc93a1def1ea4b91d41ca6fd87485b530ac12af3', class: "left-header-container" }, this.parentLink && (h("wui-button", { key: '5ced7f39fa55620286dd77f56b014c3211dcb180', icon: "arrow-left", type: "icon-ghost", "data-test": "link-to-previous-page", as: ['a', { ...parseHrefProp(this.parentLink.href) }], tooltip: this.parentLink.title ? `Go back to ${this.parentLink.title}` : 'Go back' })), h("div", { key: '7829fbc44e66df68531aa9be419d909546cbc59e', class: "title-container" }, this.parentLink?.title && (h(Fragment, { key: '68589a33050b2a146f4158a009a0c5a20025b0b7' }, h("h1", { key: 'a80d505cff11f12710f2a1509896a58d0a035906', class: "parent-title", title: this.parentLink.title }, this.parentLink.title), h("wui-icon", { key: '931d2e7f8a60bc9bf19d339c054ccd14c3edadd1', name: "slash", size: "xl" }))), h("h1", { key: '728c923e8a69cde8196d436fde8cf35111dbb1a4', class: "page-title", title: this.currentPageTitle }, this.currentPageTitle)), this.tag && h("wui-tag", { key: '2868ba79196027239f8cf6283abdb79a3caa1ee8', label: this.tag })), h("div", { key: 'bfa414354fccd67fc5627a606031d685ca4b1f87', class: "right-header-container" }, this.renderLastSavedTimestamp(), h("slot", { key: '19033cf10e91bd12b7c01136f76776b5c9e9b0c2', name: "status" }), (this.menu?.length ?? 0) > 0 && (h("wui-layout", { key: '8bdde4a586be99c0352f3e27d6a1789e8760efdd', type: "button-group", variant: "button-group-content-container" }, this.menu?.map((buttonProps, idx) => (h("wui-button", { key: `menu-button-${idx}`, ...buttonProps }))))))), this.description || h("slot", { key: '31b3dbe3494c0fc2f0fab404b4eab3098a01e08c', name: "description" })), h("section", { key: '20045cc1beff19ce47ceab344b0d24bb0ef3607e', class: "header-tabs-container" }, this.tabs && h("wui-tabs", { key: '7c383aae0a111339efef18238c24b4dfa30d1131', ...this.tabs }))));
    }
    get elm() { return this; }
    static get style() { return pageHeaderCss; }
}, [257, "wui-page-header", {
        "currentPageTitle": [1, "current-page-title"],
        "description": [1],
        "parentLink": [16, "parent-link"],
        "menu": [16],
        "tag": [1],
        "lastSaved": [16, "last-saved"],
        "tabs": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-page-header", "wui-button", "wui-close-button", "wui-icon", "wui-layout", "wui-loader", "wui-tab", "wui-tabs", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-page-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiPageHeader$1);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-tab":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tabs":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiPageHeader = WuiPageHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPageHeader, defineCustomElement };
